import './index.css'

import 'lazysizes'
import 'lazysizes/plugins/parent-fit/ls.parent-fit'

import { yall } from 'yall-js'
import defineComponents from './js/utils/define-components'
import { bodyElement } from './js/components/common/body-element'
import {
  createAutoplayVideosObserver,
  handleAutoplayVideos,
} from './js/utils/utils'

defineComponents()

window.bodyElement = bodyElement

window.auroraTheme = {
  ...window.auroraTheme,
  theme_version: '2.4.1',
  id: window.Shopify.theme.id,
  storeId: window.Shopify.theme.theme_store_id,
  isLicenseTheme: !!window.Shopify.theme.theme_store_id,
}

window.addEventListener('shopify:section:load', () => {
  yall({
    lazyClass: 'yall-video-lazy',
  })
})

window.addEventListener('load', () => {
  yall({
    lazyClass: 'yall-video-lazy',
  })

  const { observedVideos, observer } = createAutoplayVideosObserver()

  document.body.addEventListener('touchstart', () =>
    handleAutoplayVideos({ observedVideos, observer }),
  )
})
